import { siteMeta, stats } from '@/mocks/gossip';

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden scroll-mt-24 pt-16">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-secondary-100/90 via-accent-50 to-background-50" />
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-accent-200/50 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-sun-line h-3.5 w-3.5" />
              {siteMeta.edition} · 晨间瓜速递
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-600 ring-1 ring-background-200">
              <i className="ri-calendar-line h-3.5 w-3.5 text-accent-700" />
              {siteMeta.date}
            </span>
          </div>

          <h1 className="mt-5 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-5xl">
            今天的第一口瓜，
            <br className="hidden sm:block" />
            我们替你<span className="text-primary-600">挖好了</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
            吃瓜今日早报，聚焦<strong className="text-foreground-950">晨间瓜、头条瓜与首发猛料</strong>
            。不用翻遍热搜，每天几分钟，就能快速吃完今日第一瓜。头条瓜、题材分类、热榜与深度解析，一早就送到你手里。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#gusu"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              开吃今日速递
              <i className="ri-arrow-right-line ml-2 h-4 w-4" />
            </a>
            <a
              href="#subscribe"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50/70 px-6 py-3 text-sm font-semibold text-foreground-900 backdrop-blur transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
            >
              <i className="ri-mail-send-line mr-2 h-4 w-4" />
              订阅每日早报
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {['晨间瓜', '头条瓜', '首发猛料', '影视瓜', '综艺瓜'].map((t) => (
              <span
                key={t}
                className="inline-flex items-center whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900"
              >
                <i className="ri-hashtag mr-1 h-3.5 w-3.5 text-accent-700" />
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200">
            <div className="relative aspect-[5/4] w-full overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=glamorous%20entertainment%20studio%20scene%20with%20warm%20golden%20spotlight%20and%20soft%20haze%2C%20celebrity%20silhouette%20red%20carpet%20moment%20with%20camera%20flashes%2C%20coral%20and%20amber%20colored%20glow%2C%20sparkling%20bokeh%20particles%20in%20the%20air%2C%20cinematic%20editorial%20photography%2C%20warm%20ivory%20and%20terracotta%20palette%2C%20elegant%20vibrant%20modern%20atmosphere&width=1000&height=800&seq=hero-main-2026&orientation=portrait"
                alt="吃瓜今日早报晨间娱乐头条"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
              <div className="absolute left-3 top-3">
                <span className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                  <i className="ri-flashlight-fill h-3.5 w-3.5" />
                  今日头条瓜
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <p className="text-xs text-background-200">综艺瓜 · 全网热议</p>
                <p className="mt-1 font-heading text-base font-bold leading-snug text-background-50 md:text-lg">
                  《星光补给站》第三季神秘导师阵容曝光，热搜前五持续发酵
                </p>
                <a
                  href="#gusu"
                  className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-200 hover:text-accent-100"
                >
                  看看这口瓜到底有多热 <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative border-y border-background-200 bg-background-100/70">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-5 px-4 py-6 md:px-6 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center gap-1 text-center">
              <span className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{s.value}</span>
              <span className="text-xs text-foreground-600">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}